export const HERO_IMAGE =
    "https://static.prod-images.emergentagent.com/jobs/644ea8f4-d5ef-4e59-a612-cee561351309/images/22880c48c6e9d7da2e58530f419b32de9d6b02a8c6f1cad37a82376dbbb8d42f.jpeg";

export const COACH_IMAGE =
    "https://customer-assets-0z36b82j.emergentagent.net/job_distance-fix/artifacts/i448nhu8_ChatGPT%20Image%20Sep%2021%2C%202026%2C%2002_09_12%20PM.png";

export const trackCtaClick = (ctaId) => {
    const base = process.env.REACT_APP_BACKEND_URL;
    if (!base || !ctaId) return;
    try {
        fetch(`${base}/api/cta-click`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ cta_id: ctaId }),
            keepalive: true,
        }).catch(() => {});
    } catch (e) {}
};
